import { api } from '@/lib/api';
import type { SourceCoverage } from '@waypoint/shared';

export interface FollowUpItem {
  id: string;
  contactName: string;
  company: string;
  reason: string;
  /** Deal rows: what to do and why, in the sales engine's words. */
  detail: string | null;
  urgency: 'critical' | 'high' | 'medium' | 'low';
  urgencyScore: number;
  channelType: 'email' | 'call' | 'meeting';
  suggestedAction: string;
  relatedDealValue: number;
  /** clients.id for drill-down; null when the API could not link the row. */
  clientId: string | null;
  /** Deal rows: the deal-book id (opens the deal room) and the engine's reason. */
  dealId: string | null;
  signalReason: string | null;
  /** Deal rows: the Deal Coach key + fingerprint that /v1/sales/signals/state marks done or snoozes. */
  signalKey: string | null;
  fingerprint: string | null;
  evidence: Array<{ kind: string; text: string; at?: string | null }>;
}

export interface FollowUpResult {
  items: FollowUpItem[];
  /** null unless every source that feeds the queue is connected and synced: a zero count is a claim. */
  totalContacts: number | null;
  coverage?: SourceCoverage;
  scope?: {
    level: 'org' | 'team' | 'self' | 'none';
    label: string;
    isOrgWide: boolean;
    departmentIds: string[];
    departmentNames: string[];
    attributionEmailCount: number;
  };
}

export async function getFollowUpQueue(): Promise<FollowUpResult> {
  return api('/v1/follow-up/queue');
}
